import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { TonConnectUIProvider } from "@tonconnect/ui-react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TonConnectUIProvider
        manifestUrl="https://miniapp.worldofdypians.com/tonconnect-manifest.json"
        actionsConfiguration={{
          twaReturnUrl: 'https://t.me/WorldOfDypians_bot/wod'
        }}
        
      >
        <App />
      </TonConnectUIProvider>
    </BrowserRouter>
  </React.StrictMode>
);
